// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var DataCacheToolRayType;
(function (DataCacheToolRayType) {
    DataCacheToolRayType[DataCacheToolRayType["NoRay"] = 0] = "NoRay";
    DataCacheToolRayType[DataCacheToolRayType["DoubleRay"] = 2] = "DoubleRay";
    DataCacheToolRayType[DataCacheToolRayType["LeftRay"] = 3] = "LeftRay";
    DataCacheToolRayType[DataCacheToolRayType["RightRay"] = 4] = "RightRay";
    DataCacheToolRayType[DataCacheToolRayType["Ray"] = 1] = "Ray";
})(DataCacheToolRayType || (DataCacheToolRayType = {}));
export var DataCacheToolType;
(function (DataCacheToolType) {
    DataCacheToolType[DataCacheToolType["None"] = -1] = "None";
    DataCacheToolType[DataCacheToolType["TradingTool"] = 0] = "TradingTool";
    DataCacheToolType[DataCacheToolType["HorizontalLine"] = 1] = "HorizontalLine";
    DataCacheToolType[DataCacheToolType["VerticalLine"] = 2] = "VerticalLine";
    DataCacheToolType[DataCacheToolType["Line"] = 3] = "Line";
    DataCacheToolType[DataCacheToolType["Rectangle"] = 4] = "Rectangle";
    DataCacheToolType[DataCacheToolType["Triangle"] = 5] = "Triangle";
    DataCacheToolType[DataCacheToolType["Polygon"] = 6] = "Polygon";
    DataCacheToolType[DataCacheToolType["Circle"] = 7] = "Circle";
    DataCacheToolType[DataCacheToolType["Ellipse"] = 8] = "Ellipse";
    DataCacheToolType[DataCacheToolType["AndrewsPitchFork"] = 9] = "AndrewsPitchFork";
    DataCacheToolType[DataCacheToolType["PriceChannel"] = 10] = "PriceChannel";
    DataCacheToolType[DataCacheToolType["FibonacciRetracement"] = 11] = "FibonacciRetracement";
    DataCacheToolType[DataCacheToolType["FibonacciExpansion"] = 12] = "FibonacciExpansion";
    DataCacheToolType[DataCacheToolType["FibonacciArc"] = 13] = "FibonacciArc";
    DataCacheToolType[DataCacheToolType["FibonacciSpiral"] = 14] = "FibonacciSpiral";
    DataCacheToolType[DataCacheToolType["FibonacciEllipse"] = 15] = "FibonacciEllipse";
    DataCacheToolType[DataCacheToolType["FibonacciFans"] = 16] = "FibonacciFans";
    DataCacheToolType[DataCacheToolType["FibonacciPhiChannel"] = 17] = "FibonacciPhiChannel";
    DataCacheToolType[DataCacheToolType["FibonacciTimeGoal"] = 18] = "FibonacciTimeGoal";
    DataCacheToolType[DataCacheToolType["FibonacciTimeZone"] = 19] = "FibonacciTimeZone";
    DataCacheToolType[DataCacheToolType["GannLine"] = 20] = "GannLine";
    DataCacheToolType[DataCacheToolType["GannFan"] = 21] = "GannFan";
    DataCacheToolType[DataCacheToolType["GannGrid"] = 22] = "GannGrid";
    DataCacheToolType[DataCacheToolType["InfoLine"] = 23] = "InfoLine";
    DataCacheToolType[DataCacheToolType["Symbol"] = 24] = "Symbol";
    DataCacheToolType[DataCacheToolType["Text"] = 25] = "Text";
    DataCacheToolType[DataCacheToolType["Arrow"] = 26] = "Arrow";
    DataCacheToolType[DataCacheToolType["Uncpecified"] = 27] = "Uncpecified";
    DataCacheToolType[DataCacheToolType["Label"] = 28] = "Label";
    DataCacheToolType[DataCacheToolType["LineByAngle"] = 29] = "LineByAngle";
    DataCacheToolType[DataCacheToolType["RegressionChannel"] = 30] = "RegressionChannel";
    DataCacheToolType[DataCacheToolType["ABCPatern"] = 31] = "ABCPatern";
    DataCacheToolType[DataCacheToolType["PPZ"] = 32] = "PPZ";
    DataCacheToolType[DataCacheToolType["TopBottomPattern"] = 33] = "TopBottomPattern";
    DataCacheToolType[DataCacheToolType["ButterflyGartley"] = 34] = "ButterflyGartley";
    DataCacheToolType[DataCacheToolType["ElliottImpulse"] = 35] = "ElliottImpulse";
    DataCacheToolType[DataCacheToolType["ElliottCorrection"] = 36] = "ElliottCorrection";
    DataCacheToolType[DataCacheToolType["ElliottTriangle"] = 37] = "ElliottTriangle";
    DataCacheToolType[DataCacheToolType["ElliottTripleCombo"] = 38] = "ElliottTripleCombo";
    DataCacheToolType[DataCacheToolType["ElliottDoubleCombo"] = 39] = "ElliottDoubleCombo";
    DataCacheToolType[DataCacheToolType["FibonacciTools"] = 40] = "FibonacciTools";
    DataCacheToolType[DataCacheToolType["GannTools"] = 41] = "GannTools";
    DataCacheToolType[DataCacheToolType["ElliottTools"] = 42] = "ElliottTools";
    DataCacheToolType[DataCacheToolType["GeometryTools"] = 43] = "GeometryTools";
    DataCacheToolType[DataCacheToolType["TrendTools"] = 44] = "TrendTools";
    DataCacheToolType[DataCacheToolType["SecondaryTools"] = 45] = "SecondaryTools";
    DataCacheToolType[DataCacheToolType["ArrowLabel"] = 46] = "ArrowLabel";
    DataCacheToolType[DataCacheToolType["CommentsLabel"] = 47] = "CommentsLabel";
    DataCacheToolType[DataCacheToolType["PriceLabel"] = 48] = "PriceLabel";
})(DataCacheToolType || (DataCacheToolType = {}));
export const DataCacheToolTypeName = Object.values(DataCacheToolType);
export const GetToolTypesByGroup = (tooltype) => {
    const T = DataCacheToolType;
    switch (tooltype) {
        case T.TrendTools:
            return [T.HorizontalLine, T.VerticalLine, T.Line, T.PriceChannel, T.RegressionChannel, T.AndrewsPitchFork];
        case T.GeometryTools:
            return [T.Triangle, T.Rectangle, T.Circle, T.Ellipse, T.Polygon];
        case T.FibonacciTools:
            return [
                T.FibonacciRetracement,
                T.FibonacciExpansion,
                T.FibonacciArc,
                T.FibonacciEllipse,
                T.FibonacciSpiral,
                T.FibonacciFans,
                T.FibonacciPhiChannel,
                T.FibonacciTimeGoal,
                T.FibonacciTimeZone
            ];
        case T.ElliottTools:
            return [
                T.ElliottImpulse,
                T.ElliottCorrection,
                T.ElliottTriangle,
                T.ElliottTripleCombo,
                T.ElliottDoubleCombo
            ];
        case T.GannTools:
            return [T.GannLine, T.GannFan, T.GannGrid];
        case T.SecondaryTools:
            return [T.InfoLine, T.ArrowLabel, T.CommentsLabel, T.PriceLabel];
        default:
            return [];
    }
};
export const GetGroupByToolType = (tooltype) => {
    switch (tooltype) {
        case DataCacheToolType.Line:
        case DataCacheToolType.VerticalLine:
        case DataCacheToolType.HorizontalLine:
        case DataCacheToolType.AndrewsPitchFork:
        case DataCacheToolType.PriceChannel:
        case DataCacheToolType.RegressionChannel:
            return DataCacheToolType.TrendTools;
        case DataCacheToolType.Triangle:
        case DataCacheToolType.Rectangle:
        case DataCacheToolType.Polygon:
        case DataCacheToolType.Circle:
        case DataCacheToolType.Ellipse:
            return DataCacheToolType.GeometryTools;
        case DataCacheToolType.FibonacciRetracement:
        case DataCacheToolType.FibonacciExpansion:
        case DataCacheToolType.FibonacciArc:
        case DataCacheToolType.FibonacciEllipse:
        case DataCacheToolType.FibonacciSpiral:
        case DataCacheToolType.FibonacciFans:
        case DataCacheToolType.FibonacciPhiChannel:
        case DataCacheToolType.FibonacciTimeGoal:
        case DataCacheToolType.FibonacciTimeZone:
            return DataCacheToolType.FibonacciTools;
        case DataCacheToolType.ElliottCorrection:
        case DataCacheToolType.ElliottImpulse:
        case DataCacheToolType.ElliottDoubleCombo:
        case DataCacheToolType.ElliottTripleCombo:
        case DataCacheToolType.ElliottTriangle:
            return DataCacheToolType.ElliottTools;
        case DataCacheToolType.GannFan:
        case DataCacheToolType.GannGrid:
        case DataCacheToolType.GannLine:
            return DataCacheToolType.GannTools;
        case DataCacheToolType.InfoLine:
        case DataCacheToolType.ArrowLabel:
        case DataCacheToolType.CommentsLabel:
        case DataCacheToolType.PriceLabel:
            return DataCacheToolType.SecondaryTools;
        default:
            return DataCacheToolType.None;
    }
};
export var SelectionModeEnum;
(function (SelectionModeEnum) {
    SelectionModeEnum[SelectionModeEnum["All"] = 0] = "All";
    SelectionModeEnum[SelectionModeEnum["X"] = 1] = "X";
    SelectionModeEnum[SelectionModeEnum["Y"] = 2] = "Y";
})(SelectionModeEnum || (SelectionModeEnum = {}));
